import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState, useEffect, useRef } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Media,
  Button,
} from "reactstrap"
import { useHistory } from "react-router-dom"

// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvRadio,
  AvRadioGroup,
} from "availity-reactstrap-validation"

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

// Import images
import user1 from "../../assets/images/user.d1a7045e.png"
import maleAvatar from "../../assets/images/users/male-avatar.png"
import femaleAvatar from "../../assets/images/users/female-avatar.png"
import othersAvatar from "../../assets/images/users/others-avatar.png"
import { ColorRing } from "react-loader-spinner"

// actions
import { editProfile, resetProfileFlag } from "../../store/actions"

import SweetAlert from "react-bootstrap-sweetalert"
import QRCode from "qrcode"

// Import PDF.js - Make sure this is properly loaded
// You need to add this to your public/index.html:
// <script src="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.min.js"></script>
// <script>pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';</script>

const ProfileBuilder = props => {
  // Get user data from localStorage
  const obj = JSON.parse(localStorage.getItem("authUser")) || {}

  // State management
  const [prof, setProf] = useState(
    obj?.ProfileImg === "" || !obj?.ProfileImg?.includes("firebase")
      ? user1
      : obj?.ProfileImg
  )

  const [email, setEmail] = useState(obj?.Email || "")
  const [name, setName] = useState("")
  const [comp, setComp] = useState("")
  const [des, setDes] = useState("")
  const [Teamname, setTeamname] = useState("")
  const [phno, setPhno] = useState("")
  const [selectedAvatar, setSelectedAvatar] = useState("")
  const [idx, setIdx] = useState(obj?._id || 1)
  const [check1, setCheck1] = useState()
  const [qrImageUrl, setQrImageUrl] = useState("")
  const [iLoader, setILoader] = useState(false)

  // PDF viewer state
  const [pdfUrl, setPdfUrl] = useState("")
  const [pdfPages, setPdfPages] = useState([])
  const [pdfLoading, setPdfLoading] = useState(false)
  const [pdfError, setPdfError] = useState(null)
  const canvasRefs = useRef([])

  // Enhanced zoom state with higher quality rendering
  const [zoomedPageIndex, setZoomedPageIndex] = useState(null)
  const [zoomCanvas, setZoomCanvas] = useState(null)
  const [zoomScale, setZoomScale] = useState(1)
  const [panPosition, setPanPosition] = useState({ x: 0, y: 0 })
  const [isDragging, setIsDragging] = useState(false)
  const [lastPanPoint, setLastPanPoint] = useState({ x: 0, y: 0 })

  // Alert states
  const [alert, setAlert] = useState(false)
  const [redirect, setRedirect] = useState(false)

  const history = useHistory()

  // Initialize component data
  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const authUser = JSON.parse(localStorage.getItem("authUser"))

      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        setName(`${authUser.Firstname || ""} ${authUser.Lastname || ""}`.trim())
        setEmail(authUser.Email || "")
        setIdx(authUser._id)
        setComp(authUser.Company || "")
        setTeamname(authUser.Teamname || "")
        setDes(authUser.Designation || "")
        setPhno(authUser.PhoneNumber || "")
        setCheck1(authUser.check1)
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        setName(authUser.username || "")
        setEmail(authUser.email || "")
        setIdx(authUser.uid)
      }
    }
  }, [props.success])

  // Load PDF when phno is available
  useEffect(() => {
    if (phno) {
      console.log("📄 phno available, loading PDF for:", phno)
      loadPdf()
    }
  }, [phno])

  // Handle escape key to close zoom
  useEffect(() => {
    const handleEscKey = event => {
      if (event.key === "Escape" && zoomedPageIndex !== null) {
        closeZoom()
      }
    }

    document.addEventListener("keydown", handleEscKey)
    return () => document.removeEventListener("keydown", handleEscKey)
  }, [zoomedPageIndex])

  // Enhanced zoom controls with mouse wheel
  useEffect(() => {
    const handleWheel = event => {
      if (zoomedPageIndex !== null) {
        event.preventDefault()
        const delta = event.deltaY > 0 ? -0.1 : 0.1
        setZoomScale(prev => Math.max(0.5, Math.min(5, prev + delta)))
      }
    }

    if (zoomedPageIndex !== null) {
      document.addEventListener("wheel", handleWheel, { passive: false })
      return () => document.removeEventListener("wheel", handleWheel)
    }
  }, [zoomedPageIndex])

  // Function to generate PDF URL based on phno
  const generatePdfUrl = userphno => {
    if (!userphno) {
      console.warn("⚠️ No phno provided for PDF URL generation")
      return ""
    }

    const baseUrl =
      "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/salaried%20pl%202025%2FFlight%20Tickets%2F"
    const token = "48368bf8-6dc5-4b77-bdf6-c1f80eb38607"
    const url = `${baseUrl}${encodeURIComponent(
      userphno
    )}.pdf?alt=media&token=${token}`

    console.log("🔗 Generated PDF URL:", url)
    return url
  }

  // Load PDF using PDF.js
  const loadPdf = async () => {
    if (!phno) {
      console.warn("⚠️ Cannot load PDF: No phno available")
      return
    }

    const url = generatePdfUrl(phno)
    setPdfUrl(url)

    // Check if PDF.js is available
    if (typeof pdfjsLib === "undefined") {
      console.error(
        "❌ PDF.js library not loaded. Please add the script tags to your HTML."
      )
      setPdfError("PDF viewer not available. Please refresh the page.")
      return
    }

    try {
      console.log("📄 Loading PDF from URL:", url)
      setPdfLoading(true)
      setPdfError(null)
      setPdfPages([])

      // Load PDF document
      const pdf = await pdfjsLib.getDocument(url).promise

      // Load all pages
      const pages = []
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i)
        pages.push({ pageNum: i, page })
      }

      setPdfPages(pages)

      // Render pages after they're loaded with higher quality
      setTimeout(() => renderPdfPages(pages), 100)
    } catch (error) {
      console.error("❌ Error loading PDF:", error)
      setPdfError(`Failed to load PDF: ${error.message}`)
    } finally {
      setPdfLoading(false)
    }
  }

  // Enhanced PDF rendering with higher quality for thumbnails
  const renderPdfPages = async pages => {
    try {
      for (let i = 0; i < pages.length; i++) {
        const { page } = pages[i]
        const canvas = canvasRefs.current[i]

        if (canvas) {
          const context = canvas.getContext("2d")

          // Use higher scale for better quality thumbnails
          const scale = 2.0 // Increased from 1.5 for better quality
          const viewport = page.getViewport({ scale })

          canvas.height = viewport.height
          canvas.width = viewport.width

          // Set canvas display size to maintain layout
          // canvas.style.width = `${viewport.width / 2}px`
          // canvas.style.height = `${viewport.height / 2}px`

          const renderContext = {
            canvasContext: context,
            viewport: viewport,
          }

          await page.render(renderContext).promise
        }
      }
    } catch (error) {
      console.error("❌ Error rendering PDF pages:", error)
    }
  }

  // Enhanced page click handler with high-quality zoom rendering
  const handlePageClick = async pageIndex => {
    if (zoomedPageIndex === pageIndex) {
      closeZoom()
      return
    }

    const pageData = pdfPages[pageIndex]
    if (!pageData) return

    try {
      // Create a high-resolution canvas for zoomed view
      const canvas = document.createElement("canvas")
      const context = canvas.getContext("2d")

      // Get device pixel ratio for crisp rendering on high-DPI displays
      const devicePixelRatio = window.devicePixelRatio || 1

      // Calculate optimal scale for very high quality
      const vw = window.innerWidth
      const vh = window.innerHeight
      const page = pageData.page
      const baseViewport = page.getViewport({ scale: 1 })

      // Use much higher base scale for crystal clear quality
      const baseScale = 4.0 // Increased from 1 for much higher quality

      // Calculate scale to fit the page in viewport while maintaining aspect ratio
      const scaleX = (vw * 0.9) / baseViewport.width
      const scaleY = (vh * 0.9) / baseViewport.height
      const fitScale = Math.min(scaleX, scaleY)

      // Final scale combines high quality base scale with fit scale
      const finalScale = baseScale * fitScale
      const scaledViewport = page.getViewport({ scale: finalScale })

      // Set canvas size with device pixel ratio consideration
      canvas.width = scaledViewport.width * devicePixelRatio
      canvas.height = scaledViewport.height * devicePixelRatio

      // Scale the canvas back down using CSS for crisp rendering
      canvas.style.width = `${scaledViewport.width}px`
      canvas.style.height = `${scaledViewport.height}px`

      // Scale the context to match device pixel ratio
      context.scale(devicePixelRatio, devicePixelRatio)

      const renderContext = {
        canvasContext: context,
        viewport: scaledViewport,
      }

      // Render with high quality settings
      const renderTask = page.render(renderContext)
      await renderTask.promise

      setZoomCanvas(canvas)
      setZoomedPageIndex(pageIndex)
      setZoomScale(1) // Reset zoom scale
      setPanPosition({ x: 0, y: 0 }) // Reset pan position
    } catch (error) {
      console.error("❌ Error creating zoomed view:", error)
    }
  }

  // Close zoom view and reset all zoom states
  const closeZoom = () => {
    setZoomedPageIndex(null)
    setZoomCanvas(null)
    setZoomScale(1)
    setPanPosition({ x: 0, y: 0 })
    setIsDragging(false)
    setLastPanPoint({ x: 0, y: 0 })
  }

  // Enhanced mouse handlers for pan functionality
  const handleMouseDown = e => {
    if (zoomScale > 1) {
      setIsDragging(true)
      setLastPanPoint({ x: e.clientX, y: e.clientY })
    }
  }

  const handleMouseMove = e => {
    if (isDragging && zoomScale > 1) {
      const deltaX = e.clientX - lastPanPoint.x
      const deltaY = e.clientY - lastPanPoint.y

      setPanPosition(prev => ({
        x: prev.x + deltaX,
        y: prev.y + deltaY,
      }))

      setLastPanPoint({ x: e.clientX, y: e.clientY })
    }
  }

  const handleMouseUp = () => {
    setIsDragging(false)
  }

  // Handle profile image upload
  const handleProfileImageUpload = async file => {
    if (file.size > 1100000) {
      alert("File is too big! Please select a file smaller than 1MB.")
      return
    }

    setILoader(true)

    try {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(file)

      fileReader.onload = async () => {
        try {
          const response = await fetch(
            process.env.REACT_APP_ADMIN + "/updateProfile/prof",
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                Email: email,
                Profile: fileReader.result,
              }),
            }
          )

          const data = await response.json()
          if (data.ProfileImg) {
            setProf(data.ProfileImg)
          }
        } catch (error) {
          console.error("Upload error:", error)
          alert("Failed to upload image. Please try again.")
        } finally {
          setILoader(false)
        }
      }

      fileReader.onerror = () => {
        console.error("File reading error")
        setILoader(false)
        alert("Failed to read file. Please try again.")
      }
    } catch (error) {
      console.error("Upload error:", error)
      setILoader(false)
    }
  }

  // Handle form submission
  const handleValidSubmit = (event, values) => {
    props.editProfile(values)
    setAlert(true)
    setRedirect(true)
  }

  // Handle avatar selection
  const handleAvatarSelect = avatar => {
    setSelectedAvatar(avatar)
    if (avatar === "maleAvatar") setProf(maleAvatar)
    else if (avatar === "femaleAvatar") setProf(femaleAvatar)
    else if (avatar === "othersAvatar") setProf(othersAvatar)
  }

  // Alert toggle
  const alertToggle = () => {
    setAlert(!alert)
  }

  // Redirect toggle
  const redirectToggle = () => {
    if (redirect) {
      window.location.href = "/page/lobby"
    }
  }

  const downloadPdfWithFetch = async () => {
    if (!phno) {
      alert("No phno available for PDF download")
      return
    }

    try {
      setILoader(true) // Show loading spinner
      const url = generatePdfUrl(phno)

      // Fetch the PDF as a blob
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const blob = await response.blob()

      // Create download link
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = downloadUrl
      link.download = `Flight_Ticket_${phno
        .replace("@", "_at_")
        .replace(/\./g, "_")}.pdf`

      // Trigger download
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      // Clean up
      window.URL.revokeObjectURL(downloadUrl)
    } catch (error) {
      console.error("Error downloading PDF:", error)
      alert("Failed to download PDF. Please try again.")
    } finally {
      setILoader(false) // Hide loading spinner
    }
  }

  return (
    <React.Fragment>
      <SweetAlert
        show={alert}
        success
        title="Profile Updated!"
        onConfirm={redirectToggle}
        confirmBtnStyle={{ backgroundColor: "#08107b", color: "white" }}
      >
        Your profile has been updated successfully.
      </SweetAlert>

      {/* Enhanced Zoom Overlay with pan and zoom controls */}
      {zoomedPageIndex !== null && zoomCanvas && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.95)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            cursor:
              zoomScale > 1 ? (isDragging ? "grabbing" : "grab") : "pointer",
            overflow: "hidden",
          }}
          onClick={e => {
            if (e.target === e.currentTarget) closeZoom()
          }}
          // onMouseDown={handleMouseDown}
          // onMouseMove={handleMouseMove}
          // onMouseUp={handleMouseUp}
          // onMouseLeave={handleMouseUp}
        >
          {/* Enhanced Control Panel */}
          <div
            style={{
              position: "absolute",
              top: "15px",
              right: "15px",
              display: "flex",
              gap: "8px",
              zIndex: 10000,
            }}
          >
            {/* Zoom Out Button */}
            {/* <button
              onClick={e => {
                e.stopPropagation()
                setZoomScale(prev => Math.max(0.5, prev - 0.2))
              }}
              style={{
                background: "rgba(255, 255, 255, 0.9)",
                border: "2px solid #4187ad",
                borderRadius: "8px",
                width: "40px",
                height: "40px",
                fontSize: "18px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
              }}
              title="Zoom Out"
            >
              −
            </button> */}

            {/* Zoom Level Indicator */}
            {/* <div
              style={{
                background: "rgba(255, 255, 255, 0.9)",
                border: "2px solid #4187ad",
                borderRadius: "8px",
                padding: "8px 12px",
                fontSize: "12px",
                fontWeight: "bold",
                minWidth: "60px",
                textAlign: "center",
              }}
            >
              {Math.round(zoomScale * 100)}%
            </div> */}

            {/* Zoom In Button */}
            {/* <button
              onClick={e => {
                e.stopPropagation()
                setZoomScale(prev => Math.min(5, prev + 0.2))
              }}
              style={{
                background: "rgba(255, 255, 255, 0.9)",
                border: "2px solid #4187ad",
                borderRadius: "8px",
                width: "40px",
                height: "40px",
                fontSize: "18px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
              }}
              title="Zoom In"
            >
              +
            </button> */}

            {/* Reset Zoom Button */}
            {/* <button
              onClick={e => {
                e.stopPropagation()
                setZoomScale(1)
                setPanPosition({ x: 0, y: 0 })
              }}
              style={{
                background: "rgba(255, 255, 255, 0.9)",
                border: "2px solid #4187ad",
                borderRadius: "8px",
                width: "40px",
                height: "40px",
                fontSize: "12px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
              }}
              title="Reset Zoom"
            >
              ⌂
            </button> */}

            {/* Close button */}
            <button
              onClick={closeZoom}
              style={{
                background: "rgba(255, 255, 255, 0.9)",
                border: "2px solid #4187ad",
                borderRadius: "8px",
                width: "40px",
                height: "40px",
                fontSize: "18px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              title="Close (Press ESC)"
            >
              ✕
            </button>
          </div>

          {/* High-quality zoomed canvas with pan and zoom */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
              height: "100vh",
              overflow: "hidden",
              backgroundImage:
                "url(https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/salaried%20pl%202025%2Fweather.png?alt=media&token=f34fc55e-8ed1-4eeb-81d4-f481bc21c106)",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            onClick={e => e.stopPropagation()}
          >
            <canvas
              ref={canvas => {
                if (canvas && zoomCanvas) {
                  const ctx = canvas.getContext("2d")
                  canvas.width = zoomCanvas.width
                  canvas.height = zoomCanvas.height
                  canvas.style.width = zoomCanvas.style.width
                  canvas.style.height = zoomCanvas.style.height
                  ctx.drawImage(zoomCanvas, 0, 0)
                }
              }}
              style={{
                transform: `scale(${zoomScale}) translate(${
                  panPosition.x / zoomScale
                }px, ${panPosition.y / zoomScale}px)`,
                transformOrigin: "center center",
                // border: "3px solid white",
                borderRadius: "12px",
                // boxShadow: "0 0 30px rgba(255, 255, 255, 0.4)",
                maxWidth: "95vw",
                maxHeight: "95vh",
                objectFit: "contain",
                imageRendering: "crisp-edges", // Ensures sharp rendering
                transition: isDragging ? "none" : "transform 0.1s ease-out",
              }}
              onMouseDown={e => e.preventDefault()} // Prevent image dragging
              onDragStart={e => e.preventDefault()} // Prevent image dragging
            />
          </div>

          {/* Enhanced Instructions */}
          {/* <div
            style={{
              position: "absolute",
              bottom: "20px",
              left: "50%",
              transform: "translateX(-50%)",
              color: "white",
              textAlign: "center",
              fontSize: "14px",
              opacity: 0.9,
              background: "rgba(0, 0, 0, 0.7)",
              padding: "8px 16px",
              borderRadius: "20px",
              backdropFilter: "blur(10px)",
            }}
          >
            <div>
              🖱️ Scroll to zoom • Drag to pan when zoomed • ESC or ✕ to close
            </div>
            <div style={{ fontSize: "12px", marginTop: "4px", opacity: 0.8 }}>
              Page {zoomedPageIndex + 1} of {pdfPages.length}
            </div>
          </div> */}
        </div>
      )}

      <div
        className="page-content-profile"
        style={{
          minHeight: "100vh",
          backgroundImage:
            "url(https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/salaried%20pl%202025%2Fweather.png?alt=media&token=f34fc55e-8ed1-4eeb-81d4-f481bc21c106)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      >
        <MetaTags>
          <title>Flight Ticket</title>
        </MetaTags>

        <Container fluid>
          {/* Header */}
          <div className="row">
            <div className="col-12 p-3">
              <div className="d-flex align-items-center justify-content-between">
                <button
                  type="button"
                  onClick={() => history.push("/page/Lobby")}
                  className="btn btn-sm font-size-30 d-flex align-items-center"
                  id="vertical-menu-btn"
                >
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="40px"
                    viewBox="0 -960 960 960"
                    width="40px"
                    fill="#000000"
                  >
                    <path d="M560.67-240 320-480.67l240.67-240.66L608-674 414.67-480.67 608-287.33 560.67-240Z" />
                  </svg> */}
                  <img width="30" height="30" style={{marginInline: "10px"}} src="https://img.icons8.com/fluency-systems-filled/48/000000/home.png" alt="home"/>
                {/* <p className="mb-0 font-size-20 text-black judgecol text-center ">
                  Home
                </p> */}
                </button>
              </div>
            </div>
          </div>

          {/* Alerts */}
          <Row>
            <Col lg="12">
              {props.error && <Alert color="danger">{props.error}</Alert>}
              {props.success && <Alert color="success">{props.success}</Alert>}
            </Col>
          </Row>

          {/* Profile Form */}
          <Row>
            <Col>
              <Card
                style={{
                  width: "95%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "auto",
                  padding: "2rem",
                  backgroundImage:
                    "url(https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/salaried%20pl%202025%2Fweather.png?alt=media&token=f34fc55e-8ed1-4eeb-81d4-f481bc21c106)",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  boxShadow: "2px 2px 7px #08107b",
                }}
              >
                <CardBody style={{ width: "100%" }}>
                  {/* Profile Header */}
                  <Media className="">
                    <div className="align-self-center">
                      <img
                        loading="lazy"
                        src={prof}
                        alt="Profile"
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <Media body className="text-center align-self-center">
                      <div className="text-muted">
                        <h5 className="text-black">{name}</h5>
                        <p className="text-gray mb-1">{phno}</p>
                      </div>
                    </Media>
                  </Media>

                  {/* Profile Form */}
                  <AvForm
                    className="form-horizontal"
                    onValidSubmit={handleValidSubmit}
                  >
                    {/* Avatar Selection - Hidden by default */}
                    <div
                      className="form-group"
                      style={{
                        paddingTop: "1rem",
                        color: "white",
                        display: "none",
                      }}
                    >
                      <AvRadioGroup
                        name="SelectedAvatar"
                        label="Pick Your Avatar!"
                        errorMessage="Pick one Avatar!"
                      >
                        <div className="justify-content-evenly d-flex">
                          <div onClick={() => handleAvatarSelect("maleAvatar")}>
                            <img
                              loading="lazy"
                              className="avatar-md rounded-circle img-thumbnail"
                              src={maleAvatar}
                              alt="Male Avatar"
                            />
                            <AvRadio label="Male" value="maleAvatar" />
                          </div>
                          <div
                            onClick={() => handleAvatarSelect("femaleAvatar")}
                          >
                            <img
                              loading="lazy"
                              className="avatar-md rounded-circle img-thumbnail"
                              src={femaleAvatar}
                              alt="Female Avatar"
                            />
                            <AvRadio label="Female" value="femaleAvatar" />
                          </div>
                          <div
                            onClick={() => handleAvatarSelect("othersAvatar")}
                          >
                            <img
                              loading="lazy"
                              className="avatar-md rounded-circle img-thumbnail"
                              src={othersAvatar}
                              alt="Others Avatar"
                            />
                            <AvRadio label="Others" value="othersAvatar" />
                          </div>
                        </div>
                      </AvRadioGroup>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* PDF Viewer Section */}
          {phno && (
            <Row>
              <Col>
                <Card
                  style={{
                    width: "95%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "auto",
                    marginTop: "1rem",
                    padding: "1rem 0rem",
                    background: "transparent",
                  }}
                >
                  <CardBody style={{ width: "100%" }}>
                    <div className="d-flex mb-4" style={{ justifyContent: "space-evenly", alignItems: "center" }}>
                      <h4 className="text-black text-center mb-0">
                        Flight Ticket
                      </h4>

                      {/* Download Button */}
                      {pdfUrl && (
                        <Button
                          color="primary"
                          onClick={downloadPdfWithFetch}
                          disabled={iLoader}
                          className="ml-3"
                          style={{
                            backgroundColor: "#08107b",
                            borderColor: "#08107b",
                            minWidth: "120px",
                            display: "flex", alignItems: "center", justifyContent: "center", gap: "6px"
                          }}
                        >
                          {iLoader ? (
                            <>
                              <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                              Downloading...
                            </>
                          ) : (
                            <>
                              <i className="bx bx-download font-size-16 align-middle mr-2"></i>
                              Download PDF
                            </>
                          )}
                        </Button>
                      )}
                    </div>

                    {/* PDF Loading State */}
                    {pdfLoading && (
                      <div className="text-center">
                        <ColorRing
                          visible={true}
                          height="80"
                          width="80"
                          ariaLabel="color-ring-loading"
                          colors={[
                            "#e15b64",
                            "#f47e60",
                            "#f8b26a",
                            "#abbd81",
                            "#849b87",
                          ]}
                        />
                        <p className="text-white mt-2">Loading Ticket...</p>
                      </div>
                    )}

                    {/* PDF Error State */}
                    {pdfError && (
                      <Alert color="danger" className="text-center">
                        <h5 style={{ color: "black" }}>Your Ticket is not available!</h5>
                        <p>Please Contact your Coordinator.</p>
                        {/* <p>{pdfError}</p> */}
                        <Button
                          color="primary"
                          onClick={loadPdf}
                          className="mt-2"
                        >
                          Retry
                        </Button>
                      </Alert>
                    )}

                    {/* Enhanced PDF Pages with higher quality thumbnails */}
                    {pdfPages.length > 0 && (
                      <div className="pdf-pages-container">
                        {pdfPages.map((pageData, index) => (
                          <div
                            key={index}
                            className="pdf-page-wrapper"
                            style={{ marginBottom: "1rem" }}
                          >
                            <div className="text-center">
                              <canvas
                                ref={el => (canvasRefs.current[index] = el)}
                                onClick={() => handlePageClick(index)}
                                style={{
                                  border: "1px solid #08107b",
                                  boxShadow: "2px 2px 7px #08107b",
                                  borderRadius: "8px",
                                  maxWidth: "100%",
                                  backgroundColor: "white",
                                  cursor: "pointer",
                                  transition: "all 0.2s ease",
                                  imageRendering: "crisp-edges",
                                }}
                                onMouseEnter={e => {
                                  e.target.style.transform = "scale(1.02)"
                                  e.target.style.boxShadow =
                                    "0 4px 15px rgba(8, 16, 123, 0.3)"
                                }}
                                onMouseLeave={e => {
                                  e.target.style.transform = "scale(1)"
                                  e.target.style.boxShadow = "none"
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Fallback iframe for PDF display */}
                    {!pdfError &&
                      !pdfLoading &&
                      pdfPages.length === 0 &&
                      pdfUrl && (
                        <div className="text-center">
                          <p className="text-white mb-3">
                            If the PDF doesn't load above, you can view it
                            directly:
                          </p>
                          <iframe
                            src={pdfUrl}
                            style={{
                              width: "100%",
                              height: "600px",
                              border: "2px solid #08107b",
                              borderRadius: "4px",
                            }}
                            title="PDF Viewer"
                          />
                        </div>
                      )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

ProfileBuilder.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
}

const mapStateToProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStateToProps, { editProfile, resetProfileFlag })(ProfileBuilder)
)
